document.addEventListener('DOMContentLoaded', () => {
  class CategoryLinks extends HTMLElement {
    constructor() {
      super();
      this.carousel = this.querySelector("[data-carousel]");
      this.init();
    }

    init() {
      if (this.carousel != null) {
        this.initCarousel();
      }
    }

    initCarousel() {
      const splide = new Splide(this.carousel, {
        type : 'slide',
        perPage: 1,
        perMove: 1,
        autoWidth: true,
        arrows : false,
        pagination: false,
        mediaQuery: 'min',
        breakpoints: {
          1008: {
            destroy: true
          }
        },
      });
      const bar = splide.root.querySelector( '.carousel-progress-bar' );


      // Updates the bar width whenever the carousel moves:
      splide.on( 'mounted move', function () {
        var end  = splide.Components.Controller.getEnd() + 1;
        var transform = Math.min( ( splide.index ) / end, 1 );
        var width = Math.min( 1 / end, 1 );
        bar.style.transform = `translateX(${String(100 * splide.index)}%)`;
        bar.style.width = String( 100 * width ) + '%';
      } );

      splide.mount();
    }
  }

  if (!customElements.get("section-category-links")) {
    // customElements.define("section-category-links", CategoryLinks);
  }
})
